import React from 'react';
import {Table, Button, Popup} from 'semantic-ui-react';


const RoomList = ({
    rooms, activateEditRequest
}) => (
    <Table celled selectable sortable>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell>Imovina</Table.HeaderCell>
                <Table.HeaderCell>Naziv</Table.HeaderCell>
                <Table.HeaderCell>Kod</Table.HeaderCell>
                <Table.HeaderCell>Tip</Table.HeaderCell>
                <Table.HeaderCell>Sprat</Table.HeaderCell>
                <Table.HeaderCell>Površina (m<sup>2</sup>)</Table.HeaderCell>
                <Table.HeaderCell>Pristup invalidima</Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>

            </Table.Row>
        </Table.Header>

        <Table.Body>
            {rooms.map(el =>
                (
                    <Table.Row key={el.id}>
                        <Table.Cell>{el.property.name}</Table.Cell>
                        <Table.Cell>{el.name}</Table.Cell>
                        <Table.Cell>{el.code}</Table.Cell>
                        <Table.Cell>{!!el.roomType && el.roomType.name}</Table.Cell>
                        <Table.Cell>{el.floor}</Table.Cell>
                        <Table.Cell>{el.area}</Table.Cell>
                        <Table.Cell>{!!el.disabledAccess && el.disabledAccess.name}</Table.Cell>
                        <Table.Cell verticalAlign="middle" className="text-center" >
                            <Popup
                                content="Izmjena"
                                position="top center"
                                trigger={

                                    <Button
                                        basic="true"
                                        circular
                                        icon="pencil"
                                        size="tiny"
                                        color="green"
                                        disabled
                                        onClick={() => {
                                            activateEditRequest();
                                        }}
                                    />

                                }
                            />
                            <Popup
                                content="Brisanje"
                                position="top center"
                                trigger={

                                    <Button
                                        basic="true"
                                        circular
                                        disabled
                                        icon="close"
                                        size="tiny"
                                        color="red"
                                        onClick={() => {

                                        }}
                                    />

                                }
                            />
                        </Table.Cell>
                    </Table.Row>
                ))
            }
        </Table.Body>
    </Table>);

export default RoomList;



// WEBPACK FOOTER //
// ./src/views/Assets/Rooms/RoomList.js